import StaffResumeHeader from './StaffResumeHeader.component';

export default StaffResumeHeader;
